import React, { useState } from 'react';

import { useFetch, Items } from '@thinkwell/react.common'
const OrganizationsContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const OrganizationsProvider = (props) => {
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(props && props.value || []))
  const [fetchOrganizationsState, fetchOrganizations] = useFetch({onSuccess: setItems})

  return (
    <OrganizationsContext.Provider value={[items, fetchOrganizations, fetchOrganizationsState, upsertItem, getItem, deleteItem]}>
      {props.children}
    </OrganizationsContext.Provider>
  );
};

export { OrganizationsContext, OrganizationsProvider}
